import FormHelperText from "@mui/material/FormHelperText";
import { ReactNode, memo } from "react";

interface Props {
  children: ReactNode;
  className?: string;
}
function CustomHelperText({ children, className }: Props) {
  return (
    <FormHelperText
      classes={{
        root: `!mt-2 !text-platinumGranite !text-xs !font-montserrat !font-medium ${className}`
      }}
    >
      {children}
    </FormHelperText>
  );
}

CustomHelperText.defaultProps = {
  className: ""
};

export default memo(CustomHelperText);
